export const extractTemplateVariableKeys = (components) => {
  const list = Array.isArray(components) ? components : [];
  const keys = [];
  const extractKeys = (text) => {
    const found = [];
    const re = /\{\{([^}]+)\}\}/g;
    let match;
    while ((match = re.exec(String(text || ""))) !== null) {
      const key = String(match[1]).trim();
      if (key && !found.includes(key)) found.push(key);
    }
    return found;
  };

  list.forEach((comp) => {
    const type = String(comp?.type || "").toUpperCase();
    if (type === "BODY" || (type === "HEADER" && String(comp?.format || "").toUpperCase() === "TEXT")) {
      extractKeys(comp?.text).forEach((key) => {
        if (!keys.includes(key)) keys.push(key);
      });
    }
    if (type === "BUTTONS" && Array.isArray(comp?.buttons)) {
      comp.buttons.forEach((btn) => {
        if (String(btn?.type || "").toUpperCase() !== "URL") return;
        extractKeys(btn?.url).forEach((key) => {
          if (!keys.includes(key)) keys.push(key);
        });
      });
    }
  });

  return keys;
};

export const buildTemplatePreview = (components, variables = {}) => {
  const list = Array.isArray(components) ? components : [];
  const replaceVars = (text) =>
    String(text || "").replace(/\{\{([^}]+)\}\}/g, (_, key) => {
      const k = String(key).trim();
      return variables[k] !== undefined && variables[k] !== "" ? String(variables[k]) : `{{${k}}}`;
    });

  const header = list.find((c) => String(c?.type || "").toUpperCase() === "HEADER");
  const body = list.find((c) => String(c?.type || "").toUpperCase() === "BODY");
  const footer = list.find((c) => String(c?.type || "").toUpperCase() === "FOOTER");
  const buttonsComp = list.find((c) => String(c?.type || "").toUpperCase() === "BUTTONS");

  const headerText =
    header && String(header.format || "").toUpperCase() === "TEXT"
      ? replaceVars(header.text)
      : "";

  return {
    headerText,
    bodyText: replaceVars(body?.text || ""),
    footerText: replaceVars(footer?.text || ""),
    buttons: (buttonsComp?.buttons || [])
      .map((b) => {
        const type = String(b?.type || "").toUpperCase();
        const text = String(b?.text || "").trim();
        if (!text) return null;
        const btn = { text, type };
        if (type === "URL" && b?.url) {
          btn.url = replaceVars(String(b.url));
        }
        if (type === "PHONE_NUMBER" && b?.phone_number) {
          btn.phone_number = String(b.phone_number);
        }
        return btn;
      })
      .filter(Boolean),
  };
};
